<template>
  <div class="header">
    <div class="w">
      <a href="https://www.feejoy.com/">
        <div class="fl">
          <img src="../assets/images/logo.png" alt="回到首页" />
        </div>
      </a>
      <div class="fr">
        <img src="../assets/images/user.png" alt="" />
      </div>
      <div class="fr lang" v-if="uinfo">
        <el-link :underline="false" @click="goLogin()">{{
          $t("header.signOut")
        }}</el-link>
      </div>
      <div class="fr lang" v-if="!uinfo">
        <el-link :underline="false" @click="goLogin()">{{
          $t("header.signIn")
        }}</el-link>
      </div>
      <div class="fr lang">
        <span @click="changeLang('zh')" :class="{ lan: $i18n.locale == 'zh' }">
          <el-link :underline="false">zh/</el-link>
        </span>
        <span @click="changeLang('en')" :class="{ lan: $i18n.locale == 'en' }">
          <el-link :underline="false">en</el-link>
        </span>
      </div>

      <div class="fr lang">
        <el-link :underline="false" @click="goPersonal()">{{
          $t("header.personCentre")
        }}</el-link>
      </div>
      <div class="fr lang">
        <el-link :underline="false" @click="goProductHome()">{{
          $t("header.productCentre")
        }}</el-link>
      </div>
      <div class="fr lang">
        <a
          class="el-link el-link--default"
          href="http://system.feejoy.com/index/overview"
          target="_blank"
          >{{ $t("header.management") }}</a
        >
      </div>
      <div class="fr lang">
        <el-link :underline="false" @click="gosemiconductor()">{{
          $t("header.semiconductor")
        }}</el-link>
      </div>
      <div class="fr lang search">
        <el-input
          placeholder="请输入你要搜索的产品"
          v-model="titleLike"
          size="small"
          style="margin-right: 2.525rem; width: 90%;"
          @keyup.enter.native="seachEnter"
        >
          <el-button
            @click="goSearchProduct"
            slot="append"
            icon="el-icon-search"
          ></el-button>
        </el-input>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      uinfo: false,
      titleLike: undefined,
      pageSize: 9999,
    };
  },
  mounted() {
    // document.addEventListener("keydown", function(e) {
    //   if (e.key === "F12" || e.keyCode === 123) {
    //     e.preventDefault();
    //   }
    // });
    // document.addEventListener("contextmenu", function(e) {
    //   e.preventDefault();
    // });

    this.getUserInfo();
    // window.addEventListener('keydown',this.keyDown);
  },
  methods: {
    // keyDown(e){
    //     //如果是回车则执行方法
    //   if(e.keyCode == 13){
    //     this.login();
    //   }
    // },
    seachEnter(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.goSearchProduct(); //搜索按钮的回调
      }
    },
    goSearchProduct() {
      this.$router.push({
        path: "/perProduct",
        query: {
          titleLike: this.titleLike,
          pageSize: this.pageSize,
          random: Math.random(),
        },
        replace: true,
      });
    },
    async getUserInfo() {
      let { data: res } = await this.$http.get("/c/user/getInfo");
      if (res) {
        console.log(res);
        this.uinfo = res.data;
      }
    },
    // 前往登录 退出登录
    goLogin() {
      this.$router.push("/login");
      window.sessionStorageNaNpxoveItem("Authorization");
      this.uinfo = false;
    },
    // 前往产品
    goProductHome() {
      this.$router.push("/home");
    },

    gosemiconductor() {
      this.$router.push("/semiconductor");
    },

    goPersonal() {
      this.$router.push("/personal");
    },
    // 切换语言
    changeLang(val) {
      if (this.$i18n.locale == val) {
        return;
      }
      if (this.$i18n.locale == "zh") {
        this.$i18n.locale = "en";
        window.sessionStorage.setItem("lang", "en");
      } else {
        this.$i18n.locale = "zh";
        window.sessionStorage.setItem("lang", "zh");
      }
    },
  },
  watch: {
    $route(to) {
      if (
        to.path == "/personal" ||
        to.path == "/login" 
      ) {
        this.getUserInfo();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  height: 6.25rem;
  background-color: #e9eef2;
  padding-top: 1.875rem;
  box-sizing: border-box;
  line-height: 2.5rem;
  z-index: 3;
  .lang {
    margin-right: 2.225rem;
  }
  a {
    text-decoration: none;
  }
  /*正常的未被访问过的链接*/
  a:link {
    text-decoration: none;
  }
  /*已经访问过的链接*/
  a:visited {
    text-decoration: none;
  }
  /*鼠标划过(停留)的链接*/
  a:hover {
    text-decoration: none;
  }
  /* 正在点击的链接，鼠标在元素上按下还没有松开*/
  a:active {
    text-decoration: none;
  }
  /* 获得焦点的时候 鼠标松开时显示的颜色*/
  a:focus {
    text-decoration: none;
  }
  /deep/.el-input-group__append {
    padding: 0 8px;
  }
}
</style>
